import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/WalletDetails.css';

function WalletDetails({
  imgH,
  imgT,
  imgHi,
  title,
  amount,
  subText,
  bgColor = "#f8fafc",
  bgColor1 = "",
  historyLink = "",
  stateData,
  buttonText = "History", 
  disabled = false, 
  showButton = true,
  onHistoryClick
}) {
  const navigate = useNavigate();

  // Handle button click
  const handleButtonClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    
    if (onHistoryClick) {
      e.preventDefault();
      onHistoryClick();
    } else if (historyLink) {
      navigate(historyLink, { state: stateData });
    }
  };

  return (
    <div className={`wallet-card1 ${disabled ? 'disabled-card' : ''}`}>
      {/* Header */}
      <div className="wallet-header1">
        <div className="wallet-title1">
          <span className="wallet-icon1">
            <img src={imgH} alt="icon" />
          </span>
          <h3 style={disabled ? { color: '#999' } : {}}>{title}</h3>
        </div>
      </div>

      {/* Body */}
      <div className="wallet-body1" style={{ 
        backgroundColor: bgColor,
        opacity: disabled ? 0.8 : 1 
      }}>
        {/* History/Request/Withdraw Button - Conditionally rendered */}
        {showButton && (
          <div 
            className={`history-btn1 ${disabled ? 'disabled' : ''}`}
            onClick={handleButtonClick}
            style={{
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              backgroundColor: disabled ? '#e0e0e0' : 'transparent',
            }}
          >
            {imgHi && <img src={imgHi} alt="button icon" />}
            <span style={{ color: disabled ? '#999' : 'inherit' }}>
              {buttonText}
            </span>
          </div>
        )}
        
        <div className="wallet-amount1">
          <span className="wallet-icon2" style={{
            background: bgColor1,
            opacity: disabled ? 0.7 : 1
          }}>
            <img src={imgT} alt="icon" />
          </span>
          <div className="amount-text1">
            <strong style={{ color: disabled ? '#999' : 'inherit' }}>
              {amount}
            </strong>
            <p style={{ color: disabled ? '#999' : 'inherit' }}>
              {subText}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletDetails;